import { Form } from "antd"
import { useSelector } from "react-redux"
import UserRoleDropdown from "../../../UserRoleDropdown"

const emptySelection = { user: [], group: [], role: [] }

const getNormalizedSelection = (value) => {
    if (!value) {
        return { ...emptySelection }
    }
    if (typeof value === "string") {
        return { user: [value], group: [], role: [] }
    }
    if (Array.isArray(value)) {
        return { user: value.filter(Boolean), group: [], role: [] }
    }
    if (typeof value === "object") {
        return {
            user: Array.isArray(value.user) ? value.user : [],
            group: Array.isArray(value.group) ? value.group : [],
            role: Array.isArray(value.role) ? value.role : []
        }
    }
    return { ...emptySelection }
}

const UserForm = (props) => {
    const {
        id,
        values,
        handleChange,
        documentId,
        disabled = false,
        isRequestor = false
    } = props

    const { spaceSpecificUsers = [], spaceSpecificGroups = [] } = useSelector((state) => state.userRoleGroupState)

    const selectedOptions = getNormalizedSelection(values?.[id])

    // `disabled` (column/table read-only) disables the cell. `isRequestor` also
    // disables the picker: the current user is prefilled at the TableInput level
    // and shown read-only so it can't be changed.
    const pickerDisabled = disabled || isRequestor

    // When the cell is disabled, show the selected users/groups as plain text,
    // resolving emails/group ids to their display names where possible.
    if (pickerDisabled) {
        const userNames = (selectedOptions.user || []).map((email) => {
            const match = spaceSpecificUsers.find((u) => u.email === email)
            return match?.name || email
        })
        const groupNames = (selectedOptions.group || []).map((groupId) => {
            const match = spaceSpecificGroups.find((g) => g.groupId === groupId)
            return match?.name || groupId
        })
        const displayText = [...userNames, ...groupNames, ...(selectedOptions.role || [])]
            .filter(Boolean)
            .join(", ")
        return <span>{displayText}</span>
    }

    return (
        <Form.Item label="" preserve={false} style={{ marginBottom: 0 }}>
            <UserRoleDropdown
                widgetInfo={{ isUserWidget: true }}
                selectedOptions={selectedOptions}
                getSpaceUsers={true}
                tabsRequired={["user"]}
                isDisabled={pickerDisabled}
                onSelect={(value) => handleChange && handleChange(id, value, documentId)}
            />
        </Form.Item>
    )
}

export default UserForm
